import { get, post } from 'api/axiosApi';
import { env } from 'utils/env';

const url = env.REACT_APP_LEASING_API_URL;
const facilitiesURL = url + '/LeasingFacilities';

const getFacilitySublimits = (documentId, siteId) => get(`${facilitiesURL}/${documentId}/${siteId}/sublimits`);

const getFacilitySublimitFilters = (sublimitId, siteId) => get(`${facilitiesURL}/${sublimitId}/${siteId}/sublimitfilters`);

const getFacilitySublimitFinancingStructureFilters = (sublimitId, siteId) =>
  get(`${facilitiesURL}/${sublimitId}/${siteId}/sublimitfinancingstructurefilters`);

const saveFacilitySublimit = (item, documentId, siteId) => {
  return post(`${facilitiesURL}/${documentId}/${siteId}/savefacilitysublimit`, {
    item: item,
    documentId: documentId,
    siteId: siteId
  });
};

const updateFacilitySublimitFilters = (sublimitId, filters, condition, documentId, siteId) => {
  return post(`${facilitiesURL}/${documentId}/${siteId}/${sublimitId}/updateFacilitySublimitFilters`, {
    documentId,
    siteId,
    sublimitId,
    filters,
    condition
  });
};

const updateFacilitySublimitFinancingStructureFilters = (sublimitId, filters, condition, documentId, siteId) => {
  return post(`${facilitiesURL}/${documentId}/${siteId}/${sublimitId}/updateFacilitySublimitFinancingStructureFilter`, {
    documentId,
    siteId,
    sublimitId,
    filters,
    condition
  });
};

const deleteFacilitySublimit = (sublimitId, documentId, siteId) => {
  return post(`${facilitiesURL}/${documentId}/${siteId}/${sublimitId}/deletefacilitysublimit`, {
    documentId: documentId,
    siteId: siteId,
    sublimitId: sublimitId
  });
};

const exp = {
  getFacilitySublimits,
  getFacilitySublimitFilters,
  getFacilitySublimitFinancingStructureFilters,
  saveFacilitySublimit,
  updateFacilitySublimitFilters,
  updateFacilitySublimitFinancingStructureFilters,
  deleteFacilitySublimit
};
export default exp;
